import { Component, OnInit } from '@angular/core';
import {environment} from '../../environments/environment';
import {ApiService} from '../Services/Api/api.service';
import {RealmService} from '../Services/Realm/realm.service';
import {Router} from '@angular/router';
import {MenuItem} from 'primeng/api';
import {MessageService} from 'primeng/api';
import {FirebaseService} from '../Services/Firebase/firebase.service';

@Component({
  selector: 'app-renovation',
  templateUrl: './renovation.component.html',
  styleUrls: ['./renovation.component.css', '../../assets/layout/style/layout.css']
})
export class RenovationComponent implements OnInit {
  items = [];
  activeItem: MenuItem;
  env = environment;
  title: '';
  start: '';
  end: '';
  observation: '';
  constructor(private api: ApiService, private realm: RealmService, private router: Router, private messageService: MessageService, private Rc: FirebaseService) { }

  ngOnInit(): void {
    /*this.realm.loginAsync().then(val => {
      this.realm.getRenovationSettings();
      this.realm.getCouponRenovationSettings();
    });*/
    this.realm.getRenovationSettings();
    this.realm.getCouponRenovationSettings();
    // const q = JSON.parse(JSON.stringify(this.env.renovation));//resultInsuredRenewed.success;
    this.api.responseApiRenovation$.subscribe( (data: any) => {
      console.log("data renovation: ", data);
      this.env.renovation = data;
      const q = JSON.parse(JSON.stringify(data.resultInsuredRenewed.success.group));
      for (const qKey in q) {
        if (q.hasOwnProperty(qKey)) {
          const s = 'https://firebasestorage.googleapis.com/v0/b/rpn-mediprocesos-002.appspot.com/o' + q[qKey].icon + '?alt=media&token=5d34cd4a-73b3-45a5-95c7-4ac5427d6f92';
          console.log('dataRENOVATION', s);
          //this.items.push({label: q[qKey].key, icon: s, options: q[qKey].options});
        }
      }
      //this.items = q;
      
      q.map((item: any) => {
        let optionsFilter : any[] = [];
        item.options.map((option: any) => {
          let arr:any[] = option.value.split(" ");
          if (arr.length === 2) {
            if (arr[0] == '%') {
              option.value = arr[1]+" "+arr[0];
            }
          }
          optionsFilter.push(option);
        })
        item.options = optionsFilter;
        this.items.push(item);
      })
      console.log(this.items);
    });
  }
  coupons() {
    this.router.navigate(['home/coupons']);
    //this.realm.getCouponRenovationSettings();
    /*
    this.api.responseCouponRenovation$.subscribe( data => {
      const dat = JSON.parse(JSON.stringify(data));
      console.log("data coupons: ", dat);
      if (dat.code === 711) {
        const s: any = dat.resultInsuredCoupons;
        console.log('data ws Session: ', data);
        this.coupons = s;
        this.router.navigate(['home/coupons']);
      } else if (dat.code === 0) {
        this.messageService.clear();
        this.messageService.add({severity: 'info', summary: 'Información', detail: 'El usuario no tiene cupones asignados.', sticky: false});
      } else {
        // tslint:disable-next-line:max-line-length
        this.messageService.clear();
        this.messageService.add({severity: 'error', summary: 'error', detail: this.Rc.getStringRC('global_message_' + dat.code), sticky: false});
      }
    });*/
    
  }
}
